export const FUCNTION_INELIGIBLE_REASON = {
  SEAT: 'seat',
  FIRST_BAGGAGE: 'firstBaggage',
  MY_CAR_VALET: 'myCarValet',
  DUTY_FREE_PRE_ORDER: 'dutyFreePreOrder',
  YAMATO_BAGGAGE: 'yamatoBaggage',
  LOUNGE: 'lounge',
  JUNIOR_PILOT: 'juniorPilot',
  MEAL: 'meal',
  PET: 'petRakunori',
};

export const ERROR_MESSAGE_ID = {
  MY_CAR_VALET: 'E0770',
  SEAT: 'E0770',
  FIRST_BAGGAGE: 'E0770',
  LOUNGE: 'E0770',
  MEAL: 'E0770',
  DUTY_FREE_PRE_ORDER: 'E0770',
  YAMATO_BAGGAGE: 'E0770',
  PET: 'E0770',
  JUNIOR_PILOT: 'E0770',
};
